import { LoaderFunction } from 'react-router-dom';

import store from '../../../store/store';
import { getDeviceDetails, getDeviceStatus } from '../../../store/slice/health-monitor/device-details';

interface DeviceDetailsLoaderParams {
  locationName: string;
  locationId: string;
}

export const loadDeviceDetails: LoaderFunction = async ({ params }) => {
  try {
    const { locationId } = params as unknown as DeviceDetailsLoaderParams;

    await store.dispatch(getDeviceDetails(locationId));

    const deviceDetailsId = store.getState().deviceDetails.deviceDetails?.id;

    await store.dispatch(getDeviceStatus(deviceDetailsId));
  } catch (e) {
    console.log(e);

    return false;
  }

  return true;
};
